
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'RASS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/Chart_RASS.vue